import $api from '../services';

export default {
    list(params) {
        return $api.get('/sessions', params);
    },
    listFeed(params) {
        return $api.get('/sessions/feed', params);
    },
    getPlaylist(url) {
        return $api.get(url);
    },
    create(params) {
        return $api.post('/sessions', params);
    },
    createMeeting(params) {
        return $api.post('/sessions/zoom', params);
    },
    deleteMeeting(params) {
        return $api.delete('/meetings', params);
    },
    readMeetingAudience(id) {
        return $api.get(`/meetings/${id}`);
    },
    addMeetingAudience(params) {
        return $api.post('/meetings', params);
    },
    updateMeetingAudience(sessionId, params) {
        return $api.put(`/meetings/${sessionId}`, params);
    },
    meetingsList(params) {
        return $api.get('/meetings', params);
    },
    meetingsGetOne(id) {
        return $api.get(`/meetings/${id}`);
    },
    read(id) {
        return $api.get(`/sessions/${id}`);
    },
    readMeeting(id) {
        return $api.get(`/sessions/zoom/${id}`);
    },
    update(id, params) {
        return $api.put(`/sessions/${id}`, params);
    },
    updateMeeting(id, params) {
        return $api.put(`/sessions/zoom/${id}`, params);
    },
    delete(id) {
        return $api.delete(`/sessions/${id}`);
    },
    deleteZoom(id) {
        return $api.delete(`/sessions/zoom/${id}`);
    },
    startSession(id, param) {
        return $api.post(`/sessions/${id}/start`, param);
    },
    forcePlannedStart(id) {
        return $api.post(`/sessions/${id}/forcePlannedStart`);
    },
    uploadImage(param) {
        return $api.post('/sessions/photo', param);
    },
    uploadVideo(param) {
        return $api.post('/sessions/video', param);
    },
    stopSession(id, param) {
        return $api.post(`/sessions/${id}/stop`, param);
    },
    vote(id, param) {
        return $api.post(`/session-votes/${id}/vote`, param);
    },
    setWatched(id) {
        return $api.post(`/session-votes/${id}/watch`);
    },
    setReminderOnLive(id) {
        return $api.post('/session-reminders', { sessionId: id });
    },
    removeReminderFromLive(id) {
        return $api.delete(`/session-reminders/${id}`);
    },
    saveWatchedTime(param) {
        return $api.post('/statistics/viewing', param);
    },
    checkGoals() {
        return $api.get('/statistics/viewing');
    },

    updateWatchedTime(param) {
        return $api.put('/statistics/viewing', param);
    },
    // Final-flush retry path for the timer/session viewers — intermediate ticks
    // can keep firing-and-forgetting because each one carries an absolute
    // cumulative time and self-heals on the next tick. The last write before
    // unmount has no follow-up, so a transient network blip there silently
    // loses the user's minutes unless we retry.
    async updateWatchedTimeWithRetry(
        param,
        { attempts = 3, baseDelayMs = 400 } = {}
    ) {
        let resp;
        for (let i = 0; i < attempts; i++) {
            resp = await this.updateWatchedTime(param);
            if (resp.ok) return resp;
            const status = resp.status || 0;
            if (status >= 400 && status < 500) return resp;
            if (i < attempts - 1) {
                await new Promise(r => setTimeout(r, baseDelayMs * (1 << i)));
            }
        }
        return resp;
    },
    removePosterPhoto(id) {
        return $api.delete(`/sessions/${id}/poster`);
    },
    startVideoUpload(params) {
        return $api.post('sessions/video/start', params);
    },
    getAllWithInstructor() {
        return $api.get('sessions/all-with-instructor');
    },
    getAllForLandingPage() {
        return $api.get('sessions/all-for-landing-page');
    },
    uploadVideoChunks(params) {
        return $api.post('sessions/video/upload', params, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            maxBodyLength: 1000000000,
            maxContentLength: 100000000
        });
    },
    completeVideoUpload(params) {
        return $api.post('sessions/video/complete', params);
    }
};
